import { historyViews } from "@/mocks/prototype";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function HistorySection() {
  return (
    <section id="history" className="w-full bg-background-100 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="历史真实形象"
            title="“潘金莲历史真实形象”该怎么看"
            desc="关于潘金莲是否真有其人，一直有两种声音：一边是文学虚构，一边是地方传说。与其急着下结论，不如先把这几层关系分清楚。"
          />
        </Reveal>

        <Reveal className="mt-10">
          <div className="relative w-full h-[220px] md:h-[300px] rounded-lg overflow-hidden bg-secondary-100">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20ancient%20Chinese%20town%20gate%20and%20stone%20bridge%20over%20a%20misty%20canal%20at%20dusk%2C%20small%20figures%20in%20classical%20robes%2C%20ink-wash%20painting%20style%2C%20warm%20sepia%20and%20muted%20crimson%20tones%2C%20atmospheric%20fog%2C%20high%20contrast&width=1000&height=800&seq=panjinlian-history&orientation=landscape"
              alt="水墨风格的古镇石桥与雾中的人物，呼应潘金莲故事的历史与传说背景"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex items-center">
              <p className="max-w-md px-6 font-heading text-base md:text-xl font-semibold leading-relaxed text-background-50">
                民间传说有它流传的脉络，文学形象有它明确的出处，
                而“史实”需要史料来支撑——三者并不等同。
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {historyViews.map((view, idx) => (
            <Reveal key={view.label} delay={idx * 80}>
              <article className="h-full rounded-lg border border-background-200 bg-background-50 p-6">
                <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 font-label text-xs text-accent-900">
                  <i className="ri-price-tag-3-line"></i>
                  {view.label}
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {view.heading}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-700">
                  {view.text}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}